<template>
  <VueDraggableResizable :minH="60" @resizestop="resizeEnd" style="position: relative;width: 100%;" :draggable="false" :resizable="isConfig" class="page-explain" :handles="isConfig ? ['bm'] : []" :h="config.pageExplainHeight || 60">
    <div ref="titleInfo" class="page-explain-item">
      <selectEdit v-if="isConfig" @goEdit="goEdit" :isAppenDel="Boolean(config.titleInfo)" @goDel="delConfig" />
      <styleModule v-if="config.titleInfo" :parentCustomData="customData" :dataInfo="config.titleInfo.styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config.titleInfo.bgSelect" />
    </div>
    <editStyle ref="editStyle" title="编辑图片样式" :customData="customData" @on-success="confirmEdit" :modelW="`${editStyleReact.width}px`" :modelH="`${editStyleReact.height}px`" />
  </VueDraggableResizable>
</template>

<script>
import styleModule from '@/components/schoolInstrument/common/styleModule.vue'
import selectEdit from '../common/selectEdit.vue';
import editStyle from '@/components/common/editStyle/index.vue';
import VueDraggableResizable from 'vue3-draggable-resizable'
export default {
  // 组件名称
  name: 'pageExplain',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    isConfig: {
      type: Boolean,
      default: true
    },
    customData: {
      type: Array,
      default: () => ([])
    }
  },
  // 局部注册的组件
  components: {
    styleModule,
    selectEdit,
    editStyle,
    VueDraggableResizable
  },
  // 组件状态值
  data () {
    return {
      editStyleReact: {}
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    resizeEnd(x, y, width, height) {
      // eslint-disable-next-line vue/no-mutating-props
      this.config.pageExplainHeight = height
    },
    goEdit() {
      const config = this.config.titleInfo || {}
      const { styleInfo, bgSelect = '' } = config
      const react = this.$refs.titleInfo.getBoundingClientRect()
      this.editStyleReact = react
      this.$nextTick(() => {
        this.$refs.editStyle.open(styleInfo, { bgSelect })
      })
    },
    delConfig() {
      delete this.config.titleInfo
    },
    confirmEdit(val, opt = {}) {
      const obj = {
        styleInfo: val,
        bgSelect: opt.bgSelect,
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.config.titleInfo = obj
    }
  },
}
</script> 

<style scoped lang="scss">
::v-deep.page-explain {
  height: 60px;
  width: 100% !important;
  margin-top: 10px;
  position: relative;
  background-color: transparent !important;
  &-item {
    width: 100%;
    height: 100%;
  }
  .handle-bm {
    width: 8px !important;
    height: 8px !important;
    border-radius: 100%;
    background-color: #4e86ff;
    opacity: 1;
    margin-right: 0;
    border: none;
    bottom: -5px !important;
    z-index: 999;
  }
}
</style>
